/**
 * Created by RaoMeng on 2018/11/15
 * Desc: 充值缴费
 */

export default function RechargeBean() {
    this.payId = -1
    this.payNamer = ''
    this.userName = ''
    this.endTime = ''
    this.remarks = ''
    this.amount = ''
    this.status = ''
    this.statusCode = -1
}